import PublicLayout from "@/components/public-layout";

export default function How() {
  return (
    <PublicLayout>
      <h1 className="font-bold text-center">Jak działamy</h1>
    </PublicLayout>
  );
}
